module.exports = __webpack_public_path__ + "img/hohlschnitt_zinkgelb_ral1018.1990cf36.jpg";